module.exports = __webpack_public_path__ + "static/media/pic_2.cd89384d.png";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/page_app_solution/pic_2.png
// module id = 522
// module chunks = 0